import React from 'react';
import './index.scss';

const EvacuationSwitchersContainer = props => {
	return (
		<div className="evacuation-switchers-container">{props.children}</div>
	);
};

export default EvacuationSwitchersContainer;



// WEBPACK FOOTER //
// ./src/pages/evacuation-demo/containers/evacuation-switchers-container/index.js